module.exports = __webpack_public_path__ + "img/b17.72b4d026.jpg";